import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { navLinks, siteInfo } from '@/mocks/site';

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const solid = scrolled || !isHome;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        solid
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200'
          : 'bg-gradient-to-b from-foreground-950/60 to-transparent'
      }`}
    >
      <div className="px-4 md:px-8">
        <div className="h-16 md:h-20 flex items-center justify-between gap-6">
          <Link to="/" className="flex items-center gap-3 cursor-pointer shrink-0">
            <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-plant-line text-xl"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span
                className={`font-heading text-xl md:text-2xl tracking-wide ${
                  solid ? 'text-foreground-950' : 'text-background-50'
                }`}
              >
                {siteInfo.name}
              </span>
              <span
                className={`hidden sm:block text-[11px] mt-1 tracking-[0.2em] uppercase ${
                  solid ? 'text-foreground-500' : 'text-background-200'
                }`}
              >
                {siteInfo.englishName}
              </span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-md text-sm whitespace-nowrap cursor-pointer transition-colors ${
                    solid
                      ? isActive
                        ? 'text-primary-700 bg-primary-100'
                        : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                      : isActive
                        ? 'text-background-50 bg-background-50/20'
                        : 'text-background-100 hover:text-background-50 hover:bg-background-50/15'
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about#contact"
              className="px-5 py-2.5 rounded-md text-sm whitespace-nowrap cursor-pointer bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
            >
              爆料入口
            </Link>
          </div>

          <button
            type="button"
            aria-label={menuOpen ? '关闭菜单' : '打开菜单'}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
              solid ? 'text-foreground-900 bg-background-100' : 'text-background-50 bg-background-50/15'
            }`}
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 pb-5 pt-3">
          <nav className="flex flex-col" aria-label="移动端导航">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                className={({ isActive }) =>
                  `px-3 py-3 rounded-md text-base cursor-pointer ${
                    isActive ? 'text-primary-700 bg-primary-100' : 'text-foreground-800'
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>
          <Link
            to="/about#contact"
            className="mt-3 flex items-center justify-center px-5 py-3 rounded-md text-sm bg-primary-500 text-background-50 cursor-pointer"
          >
            爆料入口
          </Link>
        </div>
      )}
    </header>
  );
}